export default {
    TITLE: 'title',
    MANUAL_SMALL: 'manual-small',
    MANUAL_MEDIUM: 'manual-medium',
    MANUAL_LARGE: 'manual-large',
    TRANSITION: 'transition',
    TRAINING: 'training',
    ML_LAB: 'ml-lab',
    GAME_END: 'game-end',
};
